<template>
	<div class="kj-info">
		<div class="ball-part">
			<div class="topinfo">
				<div class="topinfo-left">
					<span class="tag">{{headobj.obj.lotteryName}}</span>
					<span class="issues">{{headobj.obj.issue}} 期</span>
					<span class="times">{{headobj.obj.dateTime}} {{headobj.obj.weekday}}</span>
				</div>
				<div class="topinfo-right" v-if="headobj.obj.prizePool!==null&&from==='H5'">
					<span class="nomalfont">奖池：</span>
					<span class="redfont">{{headobj.obj.prizePool}}元</span>
				</div>
			</div>
			
			<!-- 双色球、大乐透、排三、排五、七星彩、七乐彩 -->
			<div class="ballbannerssq" v-if="thislotid=='001'||thislotid=='113'||thislotid=='108'||thislotid=='109'||thislotid=='110'||thislotid=='003'">
				<span class="kjred" v-for="item in headobj.luckballred" :key="item">{{item}}</span>
				<template v-if="headobj.luckballblue.length!==0">
					<span class="kjbule"  v-for="itemb in headobj.luckballblue" :key="itemb">{{itemb}}</span>
				</template>
			</div>
			<!-- 福彩3D -->
			<div class="ballbanner3d" v-if="thislotid=='002'">
				<span class="kjred" v-for="item in headobj.luckballred" :key="item">{{item}}</span>
				<div class="shijihao">试机号</div>
				<span class="kjgrey" v-for="tryn in headobj.tryNumber" :key="tryn">{{tryn}}</span>
			</div>
			<!-- 胜负任九 -->
			<div class="ballbannersfr9" v-if="thislotid=='300'">
				<div class="teamindexrow">
					<span v-for="(v,index) in headobj.r9obj.caiguo" :key="index">{{index+1}}</span>
				</div>
				<div class="teamnamerow">
					<span v-for="(vn,index) in headobj.r9obj.codename" :key="index">{{vn}}</span>
				</div>
				<div class="teamcgrow">
					<span v-for="(vts,index) in headobj.lotteryNumber" :key="index">{{vts}}</span>
				</div>
			</div>
			<!-- 进球彩 -->
			<div class="ballbannerjqc" v-if="thislotid=='303'">
				<div class="teamindexrowjqc">
					<span v-for="(v,index) in headobj.r9obj.caiguo" :key="index">{{index+1}}</span>
				</div>
				<div class="teamnamerowjqc">
					<span v-for="(vn,index) in headobj.r9obj.codename" :key="index">{{vn}}</span>
				</div>
				<div class="teamcgrowjqc">
					<span v-for="(vts,index) in headobj.r9obj.caiguo" :key="index">{{vts}}</span>
				</div>
			</div>
			<!-- 半全场 -->
			<div class="ballbannerbqc" v-if="thislotid=='302'">
				<div class="teamindexrowbqc">
					<span v-for="(v,index) in headobj.bqcobj.teams" :key="index">{{index+1}}</span>
				</div>
				<div class="teamnamerowbqc">
					<span v-for="(vn,index) in headobj.bqcobj.teams" :key="index">{{vn}}</span>
				</div>
				<div class="teambqtitle">
					<span v-for="(vt,index) in headobj.bqcobj.caiguo" :key="index">{{index%2==0?'半':'全'}}</span>
				</div>
				<div class="teamcgrowbqc">
					<span v-for="(vts,index) in headobj.bqcobj.caiguo" :key="index">{{vts}}</span>
				</div>
			</div>
			
			<div class="tabpar" v-if="from!=='H5'">
				<span @click="jumph5hist(thislotid,from)">历史开奖</span>
			</div>
			<div class="topinfo-right" v-if="headobj.obj.prizePool!==null&&headobj.obj.prizePool!==''&&from==='baidu'" >
					<span class="nomalfont">奖池：</span>
					<span class="redfont">{{headobj.obj.prizePool}}元</span>
		</div>
		</div>
		
		<div class="prize-infos">
			<div class="table-header">
				<div class="td-jiangx">奖项</div>
				<div class="td-tiaojian">中奖条件</div>
				<div class="td-zhus">中奖注数</div>
				<div class="td-danzhu">单注奖金(元)</div>
			</div>
			<div class="rowtr" v-for="item in relistnewarr.arrs" :key="item.awards">
				<div class="tr-jiangx">{{item.awards}}</div>
				<div class="tr-tiaojian">{{item.winningCondition}}</div>
				<div class="tr-zhus">{{item.winningNote}}</div>
				<div class="tr-danzhu">{{item.single_Note_Bonus}}</div>
			</div>
			<template v-if="from!=='baidu'">
				<div class="click-xqs" v-if="headobj.reList.length>3&&relistnewarr.arrs.length==3" @click="slidefn('zk')"><span class="txtxq">展开详情</span><span class="iconfont">&#xe615;</span></div>
				<div class="click-xqst" v-if="headobj.reList.length>3&&relistnewarr.arrs.length>3" @click="slidefn('sq')"><span class="txtxqt">收起详情</span><span class="iconfont rot">&#xe615;</span></div>
			</template>
		</div>
		
	</div>
</template>

<script>
	//3d开奖信息返回数据缺少试机号  
	import axios from 'axios'
	import { getCurrentInstance,inject,reactive } from 'vue'
	import { useRouter } from 'vue-router'
	
	export default{
		name:'KjInfos',
		setup () {
			const baseurl = getCurrentInstance().appContext.config.globalProperties.axiosurl
			const thisIssue = inject('lottery').issue
			const thislotid = inject('lottery').lotid
			const from = inject('from')
			const router = useRouter()
			let relistnewarr = reactive({
				arrs:[]
			})
			let headobj = reactive({
				obj:{},
				luckballred:[],
				luckballblue:[],
				tryNumber:[],
				reList:[],
				r9obj:{
					caiguo:[],
					codename:[]
				},
				lotteryNumber:'',
				bqcobj:{
					caiguo:[],
					teams:[]
				}
			})
			const getInfos = async ()=>{
				
				const { data } = await axios.post(`${baseurl}/hdTransfer/methodNormal?function=getLotteryDetails_new&lotteryId=${thislotid}&issue=${thisIssue}&cache=1`)
				console.log(data)
				const { lotteryName,issue,ernie_date,weekday='',prizePool=null,lotteryId } = data
				
				if(issue){
					// 头部期次日期等
					headobj.obj = {lotteryName,issue,dateTime:ernie_date.split(' ')[0],weekday,prizePool}
					
					// 奖项/中奖条件等
					headobj.reList = data.reList
					if(from!=='baidu'){
						if(headobj.reList.length>3){
						relistnewarr.arrs = headobj.reList.slice(0,3)
						}else{
							relistnewarr.arrs = headobj.reList
						}
					}else{
						relistnewarr.arrs = headobj.reList
					}
					
					
					//开奖的球号等
					//胜负任九
					if(lotteryId=='300'||lotteryId=='303'){

						headobj.r9obj.caiguo = data.match.caiguo.split(',')
						headobj.r9obj.codename = data.match.code_des.split(',')
						headobj.lotteryNumber = data.lotteryNumber.split(',')

					}else if(lotteryId=='302'){
						headobj.bqcobj.caiguo = data.match.caiguo.split(',')
						headobj.bqcobj.teams = data.againstList.map((item,index)=>{
							return item.teams.split('VS')[0]
						})
						
					}else{
						headobj.luckballred = data.lotteryNumber.split("+")[0].split(",")
						data.lotteryNumber.split('+')[1]?headobj.luckballblue = data.lotteryNumber.split('+')[1].split(','):headobj.luckballblue=[]
						data.tryNumber?headobj.tryNumber = data.tryNumber.split(','):headobj.tryNumber = []
					}
				}
			}
			
			const slidefn = (f)=>{
				if(f=='zk'){
					relistnewarr.arrs = headobj.reList
				}else{
					relistnewarr.arrs = headobj.reList.slice(0,3)
				}
			}
			const jumph5hist = (lotid,from)=>{
				if(from==='baidu'){
					router.push({name:'History',query:{from:from},params:{lotid:lotid}})
				}else{
					router.push({name:'History',params:{lotid:lotid}})
				}
				
			}
			
			getInfos()
			return { headobj,thislotid,relistnewarr,slidefn,jumph5hist,from}
		}
	}
</script>

<style scoped="scoped">
	.kj-info{width:100%;background:#FFFFFF;padding:.15rem .15rem .05rem;box-sizing: border-box;}
	.ball-part{width:100%;display:flex;flex-direction: column;align-items: center;padding-bottom:.05rem;}
	.topinfo{width:100%;display:flex;flex-direction: row;justify-content: space-between;align-items: center;}
	.topinfo-left,.topinfo-right{display:flex;flex-direction: row;align-items: center;}
	.topinfo-right{
		justify-content: center;
	}
	.topinfo-left span,.topinfo-right .nomalfont{font-size:.13rem;color:#333333;line-height: .2rem;}
	.topinfo-left .tag{
                       margin-right: .05rem;
                            padding: .01rem .02rem;
                            background-color: #F2F9FF;
                            font-size: .1rem;
                            font-family: PingFangSC-Regular, PingFang SC;
                            font-weight: 400;
                            color: #2E7BFE;
                            line-height: .14rem;
                            border-radius: .02rem;
                   }
	.times{margin-left:.05rem;}
	.redfont{font-size:.13rem;color:#F64646;}
	.ballbannerssq,.ballbanner3d{display: flex;flex-direction: row;align-items: center;justify-content: space-around;margin-top:.2rem;}
	.ballbannerssq span,.ballbanner3d span{text-align: center;line-height: .3rem;width: .3rem;margin-right: .06rem;height: .3rem;font-size: .14rem;border-radius: 50%;-webkit-border-radius: 50%;-moz-border-radius: 50%;-ms-border-radius: 50%;-o-border-radius: 50%;}
	.ballbanner3d .shijihao{height:.3rem;line-height: .3rem;text-align: right;font-size:.13rem;width:.7rem;margin-right:.1rem;color:#999999;}
	.ballbanner3d span.kjgrey{width: .3rem;height: .3rem;background: #E8E9ED;color:#787B84;text-align: center;line-height: .3rem;margin-right: .06rem;border-radius: 50%;-webkit-border-radius: 50%;-moz-border-radius: 50%;-ms-border-radius: 50%;-o-border-radius: 50%;}
	.ballbannerssq span.kjbule{background: #2E9FFE;color: #fff;}
	.ballbannerssq span.kjred,.ballbanner3d span.kjred{background: #F44444;color: #fff;}
	.tabpar{display: flex;flex-direction: row;align-items: center;justify-content: center;margin-top:.15rem;}
	.tabpar span{width: 1.08rem;height: .35rem;background: #FFEBEB;border-radius: .04rem;line-height: .35rem;text-align: center;font-size:.13rem;color:#E81C1A;margin-left:.11rem;}
	.tabpar span:first-child{margin-left:0;}
	
	.prize-infos{width:100%;}
	.table-header,.rowtr{width:100%;display: flex;flex-direction: row;align-items: center;}
	.table-header div{text-align: center;font-size:.13rem;color:#999999;line-height: .35rem;}
	.td-jiangx{width:.8rem;}
	.td-tiaojian{width:1.25rem;}
	.td-zhus{width:.8rem;}
	.td-danzhu{width:.8rem;}
	.rowtr .tr-jiangx{width:.8rem;font-size:.13rem;color:#333333;line-height: .30rem;text-align: center;}
	.rowtr .tr-tiaojian{width:1.35rem;font-size:.13rem;color:#333333;line-height: .30rem;text-align: center;}
	.rowtr .tr-zhus{width:.8rem;font-size:.13rem;color:#333333;line-height: .30rem;text-align: center;}
	.rowtr .tr-danzhu{width:.8rem;font-size:.13rem;color:#E81C1A;line-height: .30rem;text-align: center;}
	
	.click-xqs{width:100%;height:.4rem;display: flex;flex-direction: row;align-items: center;justify-content: center;}
	.click-xqs .txtxq{font-size:.13rem;color:#999999;margin-right:.05rem;}
	.click-xqs .iconfont{font-size:.16rem;transform: rotate(90deg);}
	
	.click-xqst{width:100%;height:.4rem;display: flex;flex-direction: row;align-items: center;justify-content: center;}
	.click-xqst .txtxqt{font-size:.13rem;color:#999999;margin-right:.05rem;}
	.click-xqst .iconfont.rot{font-size:.16rem;transform: rotate(-90deg);}
	
	.ballbannersfr9{width:100%;background:#FFFFFF;display: flex;flex-direction: column;align-items: center;margin-top:.1rem;}
	.teamindexrow,.teamnamerow,.teamcgrow{display:flex;flex-direction: row;}
	.teamindexrow span,.teamnamerow span,.teamcgrow span{text-align: center;border-left:.01rem solid #F4F4F4;}
	.teamindexrow span:last-child,.teamnamerow span:last-child{text-align: center;border-right:.01rem solid #F4F4F4;}
	.teamindexrow span{width:.25rem;font-size:.14rem;line-height: .27rem;color:#333333;box-sizing: border-box;border-top:.01rem solid #F4F4F4;}
	.teamnamerow span{width:.25rem;font-size:.13rem;color:#333333;display: flex;flex-direction: column;justify-content: center;line-height: .14rem;padding: .1rem 0;box-sizing: border-box;background:#FAFAFA;}
	.teamcgrow span{width:.25rem;font-size:.14rem;line-height: .32rem;background:#F64646;color:#FFFFFF;box-sizing: border-box;border-right: 1px solid #F4F4F4;}
	
	.ballbannerjqc{width:100%;background:#FFFFFF;display: flex;flex-direction: column;align-items: center;margin-top:.1rem;}
	.teamindexrowjqc,.teamnamerowjqc,.teamcgrowjqc{display:flex;flex-direction: row;}
	.teamindexrowjqc span,.teamnamerowjqc span,.teamcgrow span{text-align: center;border-left:.01rem solid #F4F4F4;}
	.teamindexrowjqc span:last-child,.teamnamerowjqc span:last-child{text-align: center;border-right:.01rem solid #F4F4F4;}
	.teamindexrowjqc span{width:.4rem;font-size:.14rem;line-height: .2rem;color:#333333;box-sizing: border-box;border-top:.01rem solid #F4F4F4;}
	.teamnamerowjqc span{width:.4rem;font-size:.12rem;color:#333333;display: flex;flex-direction: column;justify-content: center;padding: .1rem 0;box-sizing: border-box;background:#FAFAFA;}
	.teamcgrowjqc span{width:.4rem;font-size:.14rem;line-height: .3rem;background:#F64646;color:#FFFFFF;box-sizing: border-box;text-align: center;border-right: 1px solid #F4F4F4;}
	
	.ballbannerbqc{width:100%;background:#FFFFFF;display: flex;flex-direction: column;align-items: center;margin-top:.1rem;}
	.teamindexrowbqc,.teamnamerowbqc,.teamcgrowbqc,.teambqtitle{display:flex;flex-direction: row;}
	.teamindexrowbqc span,.teamnamerowbqc span,.teamcgrow span,.teambqtitle span{text-align: center;border-left:.01rem solid #F4F4F4;}
	.teamindexrowbqc span:last-child,.teamnamerowbqc span:last-child,.teambqtitle span:last-child{text-align: center;border-right:.01rem solid #F4F4F4;}
	.teamindexrowbqc span{width:.55rem;font-size:.14rem;line-height: .27rem;color:#333333;box-sizing: border-box;border-top:.01rem solid #F4F4F4;}
	.teamnamerowbqc span{width:.55rem;font-size:.12rem;color:#333333;display: flex;flex-direction: column;justify-content: center;padding: .1rem 0;box-sizing: border-box;background:#FAFAFA;}
	.teambqtitle span{width:.275rem;font-size:.14rem;line-height: .3rem;color:#333333;box-sizing: border-box;text-align: center;}
	.teamcgrowbqc span{width:.275rem;font-size:.14rem;line-height: .3rem;background:#F64646;color:#FFFFFF;box-sizing: border-box;text-align: center;border-right: 1px solid #F4F4F4;}
	
	
</style>
